export enum DispatchBoardPanels {
  status = 0,
  tech = 1
}

